import { local } from '@ahm/common-helpers';
import { create } from 'zustand';
import { persist, devtools, createJSONStorage } from 'zustand/middleware';
import { logger } from '@/stores/logger';
import { createSelectors } from '@/stores/selectors';

export enum SubscriptionTab {
  subscription = 'subscription',
  my_subscriptions = 'my_subscriptions',
  subscriptions_history = 'subscriptions_history',
}

export interface SubscriptionState {
  activeTab: SubscriptionTab;
}

export interface SubscriptionActions {
  setActiveTab: (activeTab: string) => void;
}

const SUBSCRIPTIONS_STORE_NAME = 'ahm.subcriptions';

export const subscriptionStore = create<
  SubscriptionState & SubscriptionActions,
  [
    ['zustand/devtools', SubscriptionState & SubscriptionActions],
    ['zustand/persist', { activeTab?: null }],
  ]
>(
  logger(
    devtools(
      persist(
        (set) => {
          return {
            activeTab: SubscriptionTab.subscription,
            setActiveTab: (activeTab: SubscriptionTab) => {
              set({ activeTab });
            },
          };
        },
        {
          name: SUBSCRIPTIONS_STORE_NAME,
          storage: createJSONStorage(() => local),
        }
      )
    ),
    SUBSCRIPTIONS_STORE_NAME
  )
);

export const useSubscriptionsStore = createSelectors(subscriptionStore);
